function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default ({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  fill: "none"
}, props), /*#__PURE__*/React.createElement("g", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: "1.5",
  clipPath: "url(#a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M10 21.004H4.996a2 2 0 01-2-2.001V4.997a2 2 0 012-2h14.006a2 2 0 012 2V10M2.996 7.998h18.008"
}), /*#__PURE__*/React.createElement("path", {
  d: "M22.004 17.002a5 5 0 01-5.002 5.002v0A5 5 0 0112 17.002v0A5 5 0 0117.002 12v0a5 5 0 015.002 5.002",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16.283 15.003l2.637 1.56a.51.51 0 010 .877L16.283 19a.51.51 0 01-.77-.44v-3.118c0-.395.43-.64.77-.439",
  clipRule: "evenodd"
})), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h24v24H0z"
}))));